import React, { useState } from 'react'
import useLocation from '../../hooks/useLocation';
import useUser from '../../hooks/useUser';
import WriteLog from '../Globals/WriteLog';
import {faBuildingColumns, faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import SideBarItem from '../SideBarItem';
import { Checkbox } from '@mui/material';

function DocSideBar({routingPage}) {


    const { user } = useUser();
    WriteLog("Document->user", user)
    const navigate  = useNavigate();    
    const  {locations}  = useLocation(user?.customer_code, user?.token);
    WriteLog("Document->location", locations)
    
    const [allLocation, setAllLocation] = useState(false)
        
    function ShowAllLocation(e)
    {           
        setAllLocation(!allLocation);        
        if( allLocation == false)   
            navigate(routingPage+"/-1");
        else
            navigate(routingPage+"/0");
        
        WriteLog("LocationSidebar->allLocation", allLocation)

    }

  return (    
        <div className="w-[360px] bg-slate-100 h-screen shadow-lg rounded">        
            <div  className='flex items-center gap-4 p-5'>
                <div className='hover:bg-slate-300 bg-slate-200 rounded-full cursor-pointer p-1'>
                    <Link to="/misc" >            
                        <FontAwesomeIcon icon={faArrowLeft} className="flex h-8 w-8 shrink-0 grow-0 items-center justify-center rounded-full text-gray-400 hover:text-gray-700"/>                
                    </Link>        
                </div>
                <div className="items-center text-3xl font-semibold bg-gray-100">
                    Documents     
                </div>            
            </div>
            <div className="flex justify-between items-center  bg-gray-300 rounded-lg pl-1">            
                All Locations
                <Checkbox checked={allLocation} color="default" onClick={(e)=>{ShowAllLocation(e)}} ></Checkbox>                
            </div>                 
            <div className="ml-1 mr-1 mt-2 overflow-y-auto h-3/5">            
                {locations?.locations?.map((p) => (                    
                    <SideBarItem key={`${p.AddrSeq}`} routing="/misc/doc" addrSeq={p.AddrSeq} name={p.Name} description={p.Address} Icon={faBuildingColumns} hero={false} trigger={setAllLocation} />
                ))} 
            </div>            
        </div>
  )
}

export default DocSideBar